import Vue, { ComponentOptions } from "vue";

interface MainNav extends Vue {
    isOpen: boolean;
    view: Element | null;
    toggleNav: () => void;
}

const MainNav = {
    data() {
        return {
            isOpen: false,
            view: null,
        };
    },
    mounted(this: MainNav) {
        this.view = document.querySelector("#view");
    },
    methods: {
        toggleNav() {
            this.isOpen = !this.isOpen;

            if (this.view) {
                if (this.isOpen) {
                    document.documentElement.classList.add("is-not-scrollable");
                }
                else {
                    document.documentElement.classList.remove("is-not-scrollable");
                }
            }
        },
    },
} as ComponentOptions<MainNav>;

export { MainNav };



// WEBPACK FOOTER //
// ./src/components/mainnav.ts